<div class="popup marginBottomStyle"
    style="position: relative; overflow: hidden; height: 100%">
    <!-- <div cdkDragHandle>
        <label i18n="@@spmsUserReg" class="textColour">Filters For Dataset</label>
        <span class="example-spacer"></span>
    </div> -->
    <div style="overflow: hidden">
        <div style="height: 98%; overflow: auto">
            <!-- <form novalidate [formGroup]="formValid" >
                <div class="container">
                    <div style="max-width: 0; max-height: 0; overflow: hidden">
                        <input autofocus="true" />
                    </div>
                    <div class="row topRowMargins" style="margin-bottom: 0;">
                       
                        <div class="col-lg-12" style="    padding-right: 0;padding-left: 0;">
                            <mat-form-field appearance="outline">
                                <mat-label i18n="@@targetloginusername">
                                    Products
                                </mat-label>
                                <mat-select formControlName="filter"  [(ngModel)]="selectedProduct"  (selectionChange)="onProductSelectionChanged($event)" [sortComparator]="noCompareFunction">
                                        <mat-option *ngFor="let tempObject of productList" [value]="tempObject">
                                            {{tempObject}}
                                        </mat-option>

                                </mat-select>
                              
                            </mat-form-field>
                        </div>
                        
                    </div>
                    </div>
            </form> -->

            <div class="agGridOuterDiv" style="margin-top: 0; width: 100%;">

                <mat-toolbar class="agGridtopersDiv card" style="
                    background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8;
                    border-right: 1px solid #a9a9a9a8;border-left: 1px solid #a9a9a9a8;">
                    <label i18n="@@spmsUserReg" style="color: gray;"></label>
            
                    <span class="example-spacer"></span>
                    <div>
                        <input style="padding-left: 5px; height: 32px; color: gray; font-size: 17px; margin: 10px; border-radius: 5px; background: rgb(228 227 230 / 41%);border: 1px solid #a9a9a9a8;" type="text" placeholder="Search..."   (input)="onQuickFilterChanged($event)" />
                      </div>
            
                    <div class="insertPageNoDiv">
                        <mat-form-field appearance="outline">
                            <mat-label i18n="@@Targetpageno">Page No</mat-label>
                            <input matInput type="text" (input)="onSearchChange($event.target.value)">
                        </mat-form-field>
                    </div>
                    <div class="selectRecordsDiv" style="width:9.5%">
                        <mat-form-field appearance="outline" style="width:100%">
                            <mat-label i18n="@@Targetrecords" style="color:black">Records</mat-label>
                            <mat-select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChanged()">
                                <mat-option value="10" selected>10</mat-option>
                                <mat-option value="200">200</mat-option>
                                <mat-option value="300">300</mat-option>
                                <mat-option value="400">400</mat-option>
                            </mat-select>
            
                        </mat-form-field>
                    </div>
                    <div class="card pagination paginationFirstButton paginationFirstlastButton">
                        <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onBtFirst()"></em>
                    </div>
                    <div class="card pagination paginationButtons btn-rounded" style="width: 120px;">
                        <ul>
                            <li class="paginationliicon"><em class="fas fa-angle-left waves-effect waves-light"
                                    (click)="onBtPrevious()"></em></li>
                            <li>{{currentPage}}/{{totalPages}}</li>
                            <li class="paginationliicon" style="padding:0;"><em
                                    class="fas fa-angle-right waves-effect waves-light" (click)="onBtNext()"></em></li>
                        </ul>
                    </div>
                    <div class="card pagination paginationLastButton paginationFirstlastButton">
                        <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onBtLast()"></em>
                    </div>
                </mat-toolbar>
                <ag-grid-angular class="ag-theme-balham table-width-static-fulfilment-return tablestyles square scroolbar-dusty-grass square thin" style="height: 59vh;"
                [columnDefs]="columnDefs" [animateRows]="true"  [pagination]="true" [rowMultiSelectWithClick]="true" [rowSelection]="rowSelection"   [defaultColDef]="defaultColDef"
                [suppressPaginationPanel]="true" [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true"
                [floatingFiltersHeight]="45" [paginationPageSize]="paginationPageSize"
                [paginationNumberFormatter]="paginationNumberFormatter" [enableRangeSelection]="true" [debug]="true"
                [rowClassRules]="rowClassRules" (paginationChanged)="onPaginationChanged()"
                [components]="components" (gridReady)="onGridReady($event)" (click)="onSelectionChanged()"
                [hidden]="!true">
            </ag-grid-angular>
            <div class="row mb-1 topRowMargins" style= "position:sticky;left:0;bottom:0;width:100%">

                <div class="col-lg text-center" >
        
                    <div style="text-align: end">
        
                        <!-- <form novalidate [formGroup]="formValidCheckbox"> -->
                            
                            <button  i18n="@@TargetClear" type="button" (click)="senddata()" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean"
                            class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                            style="padding-left:1.2rem;padding-right: 1.2rem" [style.background-color]="backgroundColorButton">Proceed</button>
        
                            <button i18n="@@TargetCancel" type="button" (click)="closePopup()"
                            class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean"
                            style="padding-left:1.2rem;padding-right: 1.2rem" [style.border-color]="backgroundColorButton" >Cancel</button>        
        
                        <!-- </form> -->
        
                    </div>
         
                </div>
                
            </div>
                </div>
            </div>
            </div>
</div>
